import React, { useState, useEffect, useContext } from "react";
import { diaMes, clBasic } from "./general";
import CanvaActividad from "./CanvaActividad";
import { AppContext } from "./index";
import Trash from "./Trash";
import Boton from "./Boton";

export default function ActividadesProy({ lmax, ampliado }) {
  let { firebase } = useContext(AppContext);
  let actividades = firebase.proyectoActivo.actividades;

  // eslint-disable-next-line no-unused-vars
  const [refresh, setRefresh] = useState(false);
  const [trash, setTrash] = useState(false);
  const [change, setChange] = useState(false)

  function LineaTiempo() {
    useEffect(() => {
      // eslint-disable-next-line no-unused-vars
      let { fmenor, fmayor } = firebase.marcoFechas(actividades);
      let c = document.getElementById("canvasLT");
      let ctx = c.getContext("2d");
      ctx.strokeStyle = clBasic;
      ctx.lineWidth = 2;
      ctx.moveTo(0, 29);
      ctx.lineTo(lmax, 29);
      ctx.stroke();
      ctx.font = "16px  Arial bold";
      ctx.fillStyle = clBasic;
      ctx.fillText(diaMes(fmenor), 0, 20);
      ctx.fillText(diaMes(fmayor), lmax - ctx.measureText(diaMes(fmayor)).width, 20);
    }, []);

    return (
      <div style={SlineaTiempo}>
        <div style={Slabel}>Actividad</div>
        <canvas id="canvasLT" height="40px" width={lmax}></canvas>
        <div style={Sasignados}></div>
        {ampliado && <div style={Sprogreso}>Avance</div>}
        {ampliado && <div style={Shoras}>Hs</div>}
        {firebase.proyectoActivo.proyecto.tipo === "Agil" && <div style={Spuntos}>Pts</div>}
        <div style={Sadjuntos}>Adj</div>
      </div>
    );
  }


  useEffect(() => {
    firebase.actualizarPuntos()
  }, [refresh])

  function actualizarActividades() {
    firebase.actualizarActividadesPA();
    setChange(false)
  }

  return (
    <div id="actividadesProyecto">
      <LineaTiempo />
      <div style={SlistaActividades}>
        {actividades.map((a, ind) => {
          return (
            <div id={`${a.id}`} key={a.id}>
              <CanvaActividad ind={ind} lmax={lmax} setRefresh={setRefresh} setTrash={setTrash} ampliado={ampliado} setChange={setChange} />
            </div>
          );
        })}
      </div>
      <Boton accion={actualizarActividades} change={change} />
      <Trash visible={trash} setTrash={setTrash} />
    </div>
  );
}

//  styles para cada division
const SlistaActividades = {
  position: "relative",
  overflowY: "auto",
  height: "70vh",
  marginBottom: "10px",
  paddingLeft: "2px"
};

const SlineaTiempo = {
  position: "relative",
  display: "flex",
  flexDirection: "row",
  margin: "7px 4px 0px 0px",
  borderBottom: "dotted thin #212121",
};

const Slabel = {
  margin: "7px 12px 7px 0px",
  minWidth: "12vw",
  fontSize: "2.7vh",
  fontWeight: 700,
  textAlign: "center",
  color: clBasic,
};

const Sprogreso = {
  width: "5vw",
  margin: "7px 2px 7px 0px",
  fontSize: "2.7vh",
  fontWeight: 700,
  textAlign: "center",
  color: clBasic,
};

const Shoras = {
  width: "2.7vw",
  margin: "7px 0px 7px 15px",
  fontSize: "2.7vh",
  fontWeight: 700,
  textAlign: "left",
  color: clBasic,
};

const Spuntos = {
  width: "2.7vw",
  margin: "7px 0px 7px 15px",
  fontSize: "2.7vh",
  fontWeight: 700,
  textAlign: "left",
  color: clBasic,
};

const Sasignados = {
  width: "4vw",
  margin: "7px 0px 7px 0px",
  fontSize: "2.7vh",
  fontWeight: 700,
  textAlign: "center",
  color: clBasic,
};

const Sadjuntos = {
  width: "4vw",
  margin: "7px 0px 7px 0px",
  fontSize: "2.7vh",
  fontWeight: 700,
  textAlign: "center",
  color: clBasic,
};
